module.exports = __webpack_public_path__ + "static/media/file.76d6f2e9.svg";